import { SiteConfigRoutes } from "../SiteConfig/routes"
import { ContentManageRoutes } from "../ContentManage/routes"
// import { AuditCenterRoutes } from '../AuditCenter/routes';
import { UserManageRoutes } from "../UserManage/routes"
import { SendMessageRoutes } from "../SendMessage/routes"
import { WebCoreRoutes } from "../WebCore/routes"
import { FileManageRoutes } from "../FileManage/routes"
import { CertManageRoutes } from "../CertManage/routes"
import { ServeManageRoutes } from "../ServeManage/routes"
import { interpertDream } from "../interpertDream/routes"
export const AdminHome = [
    {
        path: "Home",
        component: () => import("./AdminHome.vue"),
        meta: {
            crumbName: "管理后台",
        },
        children: [
            {
                path: "",
                name: "数据看板",
                component: () => import("../dashboard.vue"),
                meta: {
                    title: "数据看板",
                },
            },
            ...SiteConfigRoutes,
            ...ContentManageRoutes,
            // ...AuditCenterRoutes,
            ...UserManageRoutes,
            ...SendMessageRoutes,
            ...WebCoreRoutes,
            ...FileManageRoutes,
            ...CertManageRoutes,
            ...ServeManageRoutes,
            ...interpertDream
        ],
    },
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/router/AdminHome.routes.js